export default __webpack_public_path__ + "static/media/HeroBanner_with_link.e338ef43.jpg";